import { onDocumentReady } from '../utils/events';

/**
 * Filters the cards in the single brands collection. Selecting the active
 * category again resets the section to its shared "all categories" state.
 */
onDocumentReady(() => {
  const section = document.querySelector('[data-brand-collection]');
  if (!section) return;

  const toolbar = section.querySelector('.brand-toolbar');
  if (!toolbar) return;

  const controls = Array.from(toolbar.querySelectorAll('[data-filter]'));
  const cards = Array.from(
    section.querySelectorAll('.brand-card[data-category]')
  );
  const overview = section.querySelector('[data-collection-overview]');
  const collectionHeads = Array.from(
    section.querySelectorAll('[data-collection-head]')
  );
  const filters = controls
    .map((control) => control.dataset.filter)
    .filter((filter) => filter && filter !== 'all');

  const menuLinks = Array.from(
    document.querySelectorAll('.header a[href*="#"]')
  ).filter((link) => {
    const href = link.getAttribute('href') || '';
    return filters.some((filter) => href.includes(`#${filter}`));
  });

  const apply = (filter) => {
    if (overview) {
      const isHidden = filter !== 'all';
      overview.hidden = isHidden;
      overview.classList.toggle('is-hidden', isHidden);
    }

    cards.forEach((card) => {
      const isHidden = filter !== 'all' && card.dataset.category !== filter;
      card.hidden = isHidden;
      card.classList.toggle('is-hidden', isHidden);
    });

    collectionHeads.forEach((head) => {
      const isHidden = head.dataset.category !== filter;
      head.hidden = isHidden;
      head.classList.toggle('is-hidden', isHidden);
    });

    controls.forEach((control) => {
      const isActive = control.dataset.filter === filter;
      control.classList.toggle('is-active', isActive);
      control.setAttribute('aria-pressed', isActive);
    });

    menuLinks.forEach((link) => {
      const item = link.closest('li');
      if (!item) return;
      const href = link.getAttribute('href') || '';
      const isActive = filter !== 'all' && href.includes(`#${filter}`);
      item.classList.toggle('current-menu-item', isActive);
    });
  };

  const scrollTo = (filter) => {
    const target =
      filter === 'all'
        ? toolbar
        : section.querySelector(
            `[data-collection-head][data-category="${filter}"]`
          ) || section;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const applyFromHash = (scroll) => {
    const filter = (window.location.hash || '').replace('#', '').toLowerCase();
    if (!filters.includes(filter)) return false;
    apply(filter);
    if (scroll) {
      window.requestAnimationFrame(() => scrollTo(filter));
    }
    return true;
  };

  controls.forEach((control) => {
    control.addEventListener('click', () => {
      const filter =
        control.dataset.filter !== 'all' &&
        control.classList.contains('is-active')
          ? 'all'
          : control.dataset.filter;
      apply(filter);

      if (filter === 'all') {
        history.replaceState(null, '', window.location.pathname);
      } else {
        history.replaceState(null, '', `#${filter}`);
      }
    });
  });

  // Header dropdown links (e.g. Our Brands → Skincare) point at #medical /
  // #skincare. When you are already on the collection page, a hash-only change
  // does not reliably re-run the filter, so handle same-page clicks directly.
  menuLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href') || '';
      const filter = filters.find((candidate) =>
        href.includes(`#${candidate}`)
      );
      if (!filter) return;

      let samePage = false;
      try {
        samePage =
          new URL(link.href, window.location.href).pathname ===
          window.location.pathname;
      } catch (error) {
        samePage = false;
      }
      if (!samePage) return; // let cross-page navigation happen; applyFromHash runs on load

      event.preventDefault();
      if (window.location.hash !== `#${filter}`) {
        history.replaceState(null, '', `#${filter}`);
      }
      apply(filter);
      window.requestAnimationFrame(() => scrollTo(filter));
    });
  });

  applyFromHash(true);
  window.addEventListener('hashchange', () => {
    if (!applyFromHash(true)) apply('all');
  });
});
